function handleBadgeDisplay() {
    console.log('Handling badge display');
    const promoText = document.getElementById('badge-text-container');
    const mobilePromoText = document.getElementById('badge-text-container-m');
    if (!promoText && !mobilePromoText) return;
    const checkForPromo = promoText.querySelector('.fs-custom-single-promo');
    const checkForPromoM = mobilePromoText.querySelector('.fs-custom-single-promo');
    console.log('Checking for badge text');
    console.log(checkForPromo);
    console.log(checkForPromoM);
    if (!checkForPromo || !checkForPromoM) {console.warn('No badge text found'); return;}
    const allApplicablePromos = promoText.querySelectorAll('.fs-custom-single-promo');
    const allApplicableMobilePromos = mobilePromoText.querySelectorAll('.fs-custom-single-promo');
    let activePromoFound = false;



    const getCurrentUTCTime = () => {
      const now = new Date();
      return now.toISOString();
    }

    const getStartTime = (startTime) => {
      const start = new Date(`${startTime}`);
      return start.toISOString();
    }

    const getEndTime = (endTime) => {
      const end = new Date(`${endTime}`);
      return end.toISOString();
    }

    const isPromoActive = (start, end, persist) => {
      //debugger;
      console.log('Checking if promo is active');
      if (persist == "true") { return true };
      const currentTime = getCurrentUTCTime();
      const startTime = getStartTime(start);
      const endTime = getEndTime(end);
      let isActive = currentTime >= startTime && currentTime <= endTime? true : false;
      return isActive;
    }

      for (let i = 0; i < allApplicablePromos.length; i++) {
        const currPromo = allApplicablePromos[i];
        const currPromoStart = currPromo.getAttribute('data-start-time');
        const currPromoEnd = currPromo.getAttribute('data-end-time');
        const currPromoPersist = currPromo.getAttribute('data-promo-continue');
        if (isPromoActive(currPromoStart, currPromoEnd, currPromoPersist)) {
            console.log('Promo is active');
          activePromoFound = true;

          if (window.innerWidth > 768) {
            allApplicablePromos[i].style.display = 'block';
          } else {
            allApplicableMobilePromos[i].style.display = 'block';
          }

          break;
        }
      }
  };

  if (document.readyState !== 'loading') {
    handleBadgeDisplay();
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      handleBadgeDisplay();

      /** 
      const quickviewElements = document.querySelectorAll('.product_quickview');

      if (quickviewElements.length === 0) {
        console.warn('No elements with class "product_quickview" found.');
        return; // Exit if no elements are found
      }


      // Set up a MutationObserver for each product_quickview element
      quickviewElements.forEach(quickview => {
        //debugger;
        const observer = new MutationObserver(mutations => {
          //debugger;
          mutations.forEach(mutation => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {

              if (quickview.classList.contains('active')) {
                setTimeout(() => {
                  handlePromoDisplay();
                }, 300);
              }
            }
          });
        });

        observer.observe(quickview, { attributes: true });
      });
      */
    });
  }